/* eslint-disable @tablecheck/max-mixed-css */
import { CaretRight } from '@carbon/icons-react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { TextMessage, TextTitle } from 'components/appNotices/AppNotice.styles';
import { AppNoticeTextSectionAPI } from 'components/appNotices/types';

export const TextWrapper = styled.div<{
  'data-variant'?: 'default' | 'framed';
}>`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l2);
  padding: var(--spacing-l1);

  &[data-variant='framed'] {
    background-color: var(--grey-100);
    border: 1px solid var(--border);
    border-radius: var(--border-radius-small);
  }
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-l3);
  font: var(--label);
`;

export const Details = styled.details`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l2);

  &[open] > *:not(:last-child) {
    margin-bottom: var(--spacing-l2);
  }
`;

export const DetailsMessage = styled(TextMessage)`
  background-color: var(--surface);
  padding: var(--spacing-l3);
  border: 1px solid var(--border);
  border-radius: var(--border-radius-small);
`;

export const Summary = styled.summary`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l2);
  cursor: pointer;
  &::-webkit-details-marker,
  &::marker {
    display: none;
    content: '';
  }
`;

export function AppNoticeText({
  element
}: {
  element: AppNoticeTextSectionAPI;
}): JSX.Element {
  const [t] = useTranslation();
  const {
    title_text: title,
    content_text: message,
    content_layout: textType
  } = element;

  if (textType === 'accordion') {
    return (
      <TextWrapper data-variant="framed">
        <Details>
          <Summary>
            <Label>
              <CaretRight size={20} />
              <span>{t('app_notice.actions.show_more')}</span>
            </Label>
          </Summary>
          {title ? <TextTitle>{title}</TextTitle> : null}
          <DetailsMessage>
            <div
              dangerouslySetInnerHTML={{
                __html: message
              }}
            />
          </DetailsMessage>
        </Details>
      </TextWrapper>
    );
  }

  return (
    <TextWrapper data-variant={textType}>
      {title ? <TextTitle>{title}</TextTitle> : null}
      <TextMessage>
        <div
          dangerouslySetInnerHTML={{
            __html: message
          }}
        />
      </TextMessage>
    </TextWrapper>
  );
}
/* eslint-enable @tablecheck/max-mixed-css */
